import { observer } from "mobx-react";
import { IApplicationFilterComponent } from "../BaseFilterComponents/IApplicationFilterComponent";
import React from "react";
import AcxSelectMulti from "components/UI/Select/BaseSelectComponents/AcxSelectMulti";
import { useRestrictedOptions } from "../BaseFilterComponents/useRestrictedOptions";

export const PatientJourneyStageFilter = observer(function (
    props: IApplicationFilterComponent,
) {
    const { availableOptions } = useRestrictedOptions({
        options: props.store.journeyStageOptions,
        getOptionValue: (stage) => stage.value,
        optionRestriction: props.optionRestriction,
        restrictedValues: props.restrictedValues,
    });

    return (
        <AcxSelectMulti
            id="application-filters-patient-journey-stage"
            fullWidth
            options={availableOptions}
            defaultValue={props.store.patientJourneyStages.map((i) => ({
                label: props.store.journeyStageOptions.find(
                    (stage) => stage.value === i,
                )?.label as string,
                value: i,
            }))}
            onChange={(options) => {
                props.store.setPatientJourneyStages(!!options ? options : []);
            }}
            valueField="value"
            labelField="label"
            containerHeight="auto"
            maxContainerHeight="96px"
            alignControls="flex-start"
            isClearable={true}
        />
    );
});
